<template>
    <!-- 实际处理方式级联：选项由 Search 传入（与列表页 mapDictionaryListToOptions 同源、已 i18n） -->
    <el-cascader 
    :options="cascaderOptions" 
    :placeholder="inputPlaceholder || $t('app.pleaseSelectProductType')" 
    @change="changeProduct"
    :props="{ checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'name', children: 'childList' }"
    clearable 
    v-model="result" 
    ref="cascader"></el-cascader>
</template>

<script>
export default {
    data() {
        return {
            result: []
        };
    },
    props: {
        inputPlaceholder: {
            type: String,
            default: ""
        },
        prop: {
            type: String,
            default: ""
        },
        snFilter: {
            type: Boolean,
            default: false,
        },
        /** 树形字典选项（id / name / childList），由页面在 getRecursionDictionaryList 后做 i18n 再传入 */
        cascaderOptions: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    methods: {
        // 切换商品类型
        changeProduct(node) {
            let modelParentId = null;
            let modelId = null;
            this.result = [];
            console.log(node, "node");
            if (node.length == 1) {
                modelParentId = node[0];
                this.result = [modelParentId];
            } else if (node.length == 2) {
                modelParentId = node[0];
                modelId = node[1];
                this.result = [modelParentId, modelId];
            }
            console.log(this.result);
            this.$emit("changeP", this.result);
            // this.$emit("input", result);
        },
        resetCascaderInput() {
            this.result = [];
        }
    },
};
</script>

<style lang="scss" scoped></style>